// 本番アプリ判定
export const isAppProd = process.env.APP_ENV === 'Production' || false;

// 本番起動判定 (development | production | test)
export const isNodeProd = process.env.NODE_ENV === 'production' || false;
